import { CloseCircleFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'

/** Keep Ant Design's clear behavior while naming the icon in the product language. */
export const inputClear = { clearIcon: <Tooltip title="清除输入"><CloseCircleFilled aria-label="清除输入" /></Tooltip> }
